"use strict";
// it's helpful in the Shopify backend to add a "bundle" string to product titles
// this helper functions removes it for outputting
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (title) {
    title = title.replace(/^\s?\(.*?Bundle\)\s(?:\(Discount\)\s?)?/, '');
    // diaper pattern variant names look like this:
    // a: Diaper Patterns N-2 - 1 / Arrows Up x 1
    // b: Diaper Patterns N-2 1 / Party Poopers x 2
    // c: Diaper Patterns 1 / Party Poopers x 2
    // so we can clean that up a bit
    var match = title.match(/(?:Diaper|Training Pant) Patterns (?:.\-.)? ?\-? ?(.+?) \/ (.+)/);
    if (!match)
        return title;
    return "".concat(match[2], " Size ").concat(match[1]);
});
